import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React from "react"
import { Redirect } from "react-router"
import GlobalHelper from "../../common/GlobalHelper"
import SideBar from "../../common/layout/sidebar.component"
import LoadingSpinner from "../../common/spinner/loading.component"
import PaymentProcessingTabs from "../PaymentProcessingTabs"
import { useGetPaymentAccounts } from "../usePaymentAccountSession"
import PaymentAccountListing from "./PaymentAccountListing"


const PaymentProcessingAccounts = () => {

    SideBar.activateMenu("payment-processing")

    const { paymentAccounts, isLoading, hasActiveAccount } = useGetPaymentAccounts()

    if (isLoading) {
        return <LoadingSpinner/>
    }

    const hasAllowedCurrency = GlobalHelper.getCountryCodeFromCurrency(AppContext.getCurrency()) === "US"
    return (
        <>
            {!hasAllowedCurrency ? (
                <Redirect to={"/"}/>
            ) : (
                <>
                    <PaymentProcessingTabs hasActiveAccount={hasActiveAccount} />
                    <PaymentAccountListing paymentAccounts={paymentAccounts}/>
                </>
            )}
        </>
    )
}

export default PaymentProcessingAccounts



// WEBPACK FOOTER //
// ./src/payment-processing/payment-account-listing/PaymentProcessingAccounts.tsx